<div
  class="card fs-16 bg-fff flex flex_column justify-content-between"
  [ngStyle]="{ 'border-left': '8px solid ' + borderColor }"
>
  <div class="card__heading flex_sb wd-100">
    <div class="fs-14 clr-999 fw-600">
      {{ cardTitle }}
    </div>
    <div class="card__icon">
      <span
        nz-icon
        nz-tooltip
        nzType="info-circle"
        nzTheme="outline"
        class="card__info-icon"
        nzTooltipTitle="{{ toolTipTitle }}"
        nzTooltipPlacement="left"
      ></span>
    </div>
  </div>
  <div class="card__value flex_sb wd-100">
    <div class="card__value-text fs-24 flex-align-center fw-700 clr-333">
      <span *ngIf="isAmount">{{ currency }}</span>
      <span>{{ cardValue }}</span>
      <span *ngIf="cashBalance">{{ cashBalance }}</span>
    </div>
    <div class="card__value-link wd-100" *ngIf="btnText">
      <a class="fs-12 fw-600" (click)="handleBtnClick()">{{ btnText }}</a>
    </div>
  </div>
  <div class="card__bottom flex_sb wd-100" *ngIf="previousValue">
    <div class="card__prev flex-align-center clr-333">
      <span>{{ 'INVOICE.PREV' | fallbackTranslate }} :</span>
      <span *ngIf="isAmount" class="fs-20 fw-700">{{ currency }}</span>
      <span class="fs-20 fw-700">{{ previousValue }}</span>
    </div>
    <div class="card__change flex-align-center">
      <div
        class="card__triangle"
        [ngClass]="
          isNegative(valueChanged)
            ? 'card__triangle--neg'
            : 'card__triangle--pos'
        "
      ></div>
      <div
        class="card__change-value flex-align-center"
        [ngClass]="
          isNegative(valueChanged)
            ? 'card__change-value--neg'
            : 'card__change-value--pos'
        "
      >
        {{ valueChanged || 0 }} %
      </div>
    </div>
  </div>
</div>
